import { Exposure } from "@js/libs/exposure";

export default function moodboard(opts = {}) {
    let moodboard = null;
    let moodboardEl = null;

    return {
        init() {
            moodboardEl = this.$refs.moodboardEl || this.$root;
            moodboard = new Exposure(moodboardEl, { maxHeight: 450 });
        },
        layout() {
          if(!moodboard) return;
          moodboard.layout();
        }
    };
}
